<template>
  <div class="Tabs">
    <v-card flat tile>
      <v-tabs show-arrows :height="height" v-model="selected">
        <v-tab
          v-for="tabRow in content"
          :key="tabRow.key"
          :disabled="disabled||wait"
        >{{ tabRow.title }}</v-tab>
      </v-tabs>
    </v-card>
  </div>
</template>
<script>
export default {
  props: {
    selectedTab: {
      type: Number,
      default: 0,
    },
    content: Array,
    height: {
      type: [Number, String],
      default: 55,
    },
    wait: {
      type: Boolean,
      default: false,
    },
    timeout: {
      type: Number,
      default: 1000
    }
  },
  data() {
    return {
      disabled: false,
      selected: 0,
    };
  },
  methods: {
    getTab(i) {
      this.disabled = true;
      this.$emit("getCurrentTab", this.content[i]);
      setTimeout(() => {
        this.disabled = false;
      }, this.timeout);
    },
  },
  watch: {
    selectedTab: {
      handler() {
        this.selected = this.selectedTab;
      },
    },
    selected: {
      handler(i) {
        this.getTab(i);
      },
    },
  },
};
</script>
<style scoped>
.v-tab {
  font-size: 12px;
  margin-left: 10px;
}
</style>
